<template>
  <div>
    <div v-if="broadcaststatus==false">
      <v-card elevation="0">
        <v-container>
          <v-row>
            <v-col cols="12" sm="10"></v-col>
            <v-col cols="12" sm="2">
              <v-btn color="primary" class="m3-1" @click="createMethod()" dark>Create Broadcast</v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-content>
          <v-data-table
            :headers="headers"
            :items="getAnnouncements"
            :loading="tableLoading"
            :disable="tableLoading"
            :items-per-page="10"
            :search="search"
            class="elevation-10 text-xs"
          >
            <template v-slot:item.createdon="{ item }">
              <span class="caption">{{ item.createdon }}</span>
            </template>
            <template v-slot:item.text="{ item }">
              <span class="caption">{{ item.text }}</span>
            </template>

            <!--For last column Drop down menu-->
            <template v-slot:item.Action="{item}">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon background-color="transparent" flat>mdi-view-dashboard</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title @click="actionMethod(item)">View</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
          <v-dialog v-model="itemBroadcastStatus" max-width="600px">
            <v-card elevation="0">
              <v-card-title class="secondary" height="20px">
                <span class="font-weight white--text">Details</span>
                <v-spacer></v-spacer>
                <v-icon @click="itemBroadcastStatus = false" class="white--text">mdi-close</v-icon>
              </v-card-title>
              <v-container fluid>
                <div>
                  <b>Title :</b>
                  {{itemBroadcast.text}}
                </div>
                <v-row align="center" justify="center">
                  <div class="justify-center" v-if="itemBroadcast.mediautl != null">
                    <v-img :src="itemBroadcast.mediautl" width="300" height="200px"></v-img>
                  </div>
                </v-row>
                <div>
                  <b>Description :</b>
                  {{itemBroadcast.announcementsdetails}}
                </div>
                <div v-if="itemBroadcast.callbacknumber != ''">
                  <b>Call Back Number :</b>
                  {{ itemBroadcast.callbackccode }} -
                  {{ itemBroadcast.callbacknumber }}
                </div>
                <div v-if="itemBroadcast.infosourceurl != ''">
                  <b>Information Source Url :</b>
                  <br />
                  {{itemBroadcast.infosourceurl}}
                </div>
                <div v-if="itemBroadcast.expiredate != ''">
                  <b>Expire Date :</b>
                  {{itemBroadcast.expiredate }}
                </div>
              </v-container>
            </v-card>
          </v-dialog>
        </v-content>
      </v-card>
    </div>
    <div v-if="broadcaststatus==true">
      <v-card>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="4">
              <v-container fluid class="pa-8">
                <v-text-field
                  ref="Channel_Name"
                  v-model="Channel"
                  label="Title"
                  outlined
                  dense
                  counter="40"
                  :maximum="max"
                ></v-text-field>
                <croppa
                  :placeholder-font-size="15"
                  v-model="croppa"
                  canvas-color="grey"
                  :width="190"
                  :height="150"
                  crossorigin="anonymous"
                  outlined
                  :initial-image="initialIMage"
                />
                <v-textarea
                  solo
                  v-model="descriptnBroadcast"
                  counter="5000"
                  :maximum="max_descptn"
                  label="Description"
                ></v-textarea>
                <v-btn color="primary" @click="clickOfBack()" class="mr-2">Back</v-btn>
                <v-btn color="secondary" class="ml-15" @click="SendBroadcast()">Send Broadcast</v-btn>

                <v-dialog v-model="dialogBroadcast" width="700px">
                  <v-card>
                    <v-card-title class="secondary">
                      <span class="subtitle white--text">Send Broadcast</span>
                      <v-spacer></v-spacer>
                      <v-icon @click="dialogBroadcastMethod()" class="white--text">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row align="center">
                          <v-col cols="12">
                            <v-select
                              :items="announcementList"
                              item-text="list_name"
                              item-value="list_id"
                              v-model="announcement"
                              @change="listNameChangeMethod(announcement)"
                              label="Select List Name"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <div v-if="surveyorListName.length!=0">
                          <v-data-table
                            :headers="headersAnncemtList"
                            :items="surveyorListName"
                            :items-per-page="5"
                            item-key="name"
                            :search="search"
                            class="elevation-1"
                            hide-default-footer
                            dense
                          ></v-data-table>
                        </div>
                        <template>
                          <div class="text-center">
                            <v-btn
                              color="secondary"
                              :loading="loading"
                              @click="sendBroadcastToList()"
                              class="mt-5"
                            >Save</v-btn>
                          </div>
                        </template>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-col>
            <v-col cols="12" sm="4">
              <v-container fluid class="pa-8">
                <div>
                  <v-switch
                    v-model="multiple"
                    @click="multipleMethod()"
                    dense
                    color="secondary"
                    label="Advanced Option"
                  ></v-switch>
                </div>
                <div v-if="multiple==true">
                  <v-switch
                    v-model="infrmatnUrlStatus"
                    color="primary"
                    dense
                    label="Information URL"
                  ></v-switch>
                  <v-text-field
                    v-if="infrmatnUrlStatus==true"
                    v-model="urlinformatin"
                    :rules="[rules.Urlvalid]"
                    label="URL"
                    placeholder="https://example.com"
                    dense
                    outlined
                  ></v-text-field>
                  <v-switch
                    dense
                    v-model="expiryDateStatus"
                    color="primary"
                    label="Set Expiry Date"
                  ></v-switch>

                  <v-menu
                    v-if="expiryDateStatus==true"
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFormattedView"
                        label="Date"
                        hint="MM/DD/YYYY Format"
                        append-icon="event"
                        @blur="dateAdd = parseDate(dateFormattedView)"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dateAdd" dense @input="menu2 = false"></v-date-picker>
                  </v-menu>

                  <v-switch v-model="callStatus" dense color="primary" label="Call Back Number"></v-switch>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-select
                        v-if="callStatus==true"
                        :items="contryList"
                        item-text="countryWithCC"
                        item-value="dial_cc"
                        dense
                        v-model="annoucementMobileCode"
                        label="Code"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="8">
                      <v-text-field
                        v-if="callStatus==true"
                        v-model="annoucementMobile"
                        :rules="[rules.contactNumber]"
                        label="Mobile Number"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-col>
            <v-col cols="12" sm="1"></v-col>
            <v-col cols="12" sm="3">
              <v-spacer></v-spacer>
              <div>
                <b>To:</b>
                <v-btn text small color="primary" @click="dialog=true">Select Surveyor</v-btn>
              </div>
              <v-dialog v-model="dialog" width="1100px">
                <v-card v-if="step==0">
                  <v-card-title class="secondary">
                    <span class="subtitle white--text">Select Surveyor</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="dialogBroadcastMethod()" class="white--text">mdi-close</v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col sm="12" md="8"></v-col>
                        <v-col sm="12" md="4">
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-data-table
                        v-model="selected"
                        show-select
                        :headers="headers1"
                        :items="subscribers"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        item-key="id"
                        dense
                      ></v-data-table>
                      <template>
                        <div class="text-center">
                          <v-btn
                            color="secondary"
                            class="mt-5"
                            @click="createSurveyorMethod(subscribers)"
                          >Create</v-btn>
                        </div>
                      </template>
                    </v-container>
                  </v-card-text>
                </v-card>
                <v-card v-if="step==1">
                  <v-card-title class="secondary">
                    <span class="subtitle white--text">Select Surveyor</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="dialogBroadcastMethod()" class="white--text">mdi-close</v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col sm="12" md="4">
                          <v-text-field v-model="listName" label="List Name"></v-text-field>
                        </v-col>
                        <v-col sm="12" md="4"></v-col>
                        <v-col sm="12" md="4">
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="headersAfterDelete"
                        :items="tabledataAfterDelete"
                        :items-per-page="5"
                        item-key="name"
                        :search="search"
                        class="elevation-1"
                        hide-default-footer
                        v-model="selected"
                        dense
                      ></v-data-table>

                      <template>
                        <div class="text-center">
                          <v-btn
                            color="primary"
                            class="mt-5 mr-2"
                            @click="backForToStep1('step0')"
                          >Back</v-btn>
                          <v-btn
                            color="secondary"
                            class="mt-5"
                            @click="saveAfterDelete(tabledataAfterDelete,'first')"
                          >Save</v-btn>
                        </div>
                      </template>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- <v-dialog v-model="dialogList" width="600px">
                <v-card>
                  <v-card-title class="secondary">
                    <span class="subtitle white--text">Select Surveyor</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="dialogBroadcastMethod('step0')" class="white--text">mdi-close</v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-text-field v-model="listName" label="List Name"></v-text-field>

                      <template>
                        <div class="text-center">
                          <v-btn
                            color="primary"
                            class="mt-5 mr-2"
                            @click="backForToStep1('step1')"
                          >Back</v-btn>
                          <v-btn
                            color="secondary"
                            class="mt-5"
                            @click="saveAfterDelete(tabledataAfterDelete,'first')"
                          >Save</v-btn>
                        </div>
                      </template>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>-->
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </div>
</template>

<script>
import CountryJSON from "@/components/Country.json";
import axios from "axios";
var aws = require("aws-sdk");
import moment from "moment";
export default {
  data: vm => ({
    rules: {
      required: value => !!value || "Required.",
      contactNumber: value => {
        const pattern = /^[0-9][0-9]{7,14}$/;
        return pattern.test(value) || "Only Numeric,Min-7 & Max-15";
      },
      Urlvalid: value => {
        const pattern = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
        return pattern.test(value) || "Give Proper URL";
      }
    },
    menu2: false,
    dateAdd: new Date().toISOString().substr(0, 10),
    dateFormattedView11: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateFormattedView: "",
    contryList: [],
    max_descptn: 5000,
    chooseImage: "",
    croppa: {},
    itemBroadcastStatus: false,
    itemBroadcast: [],
    initialIMage: "",
    step: 0,
    max: 40,
    descriptnBroadcast: "",
    Channel: "",
    row: null,
    dialog: false,
    callStatus: false,
    multiple: false,
    urlinformatin: "",
    annoucementMobile: "",
    annoucementMobileCode: "Select code",
    expiryDateStatus: false,
    infrmatnUrlStatus: false,
    selected: [],
    dialogList: false,
    listName: "",
    loading: false,
    loader: null,
    dialogBroadcast: false,
    search: "",
    announcement: "",
    announcementList: [],
    singleSelect: false,
    subscribers: [],
    tabledataAfterDelete: [],
    surveyorListName: [],
    headersAnncemtList: [
      { text: "Name", value: "serveyorname" },
      { text: "Phone no", value: "mobno", sortable: false },
      { text: "Email", value: "serveyoremail", width: 130, sortable: false },
      { text: "Surveyor type", value: "surveyor_type", sortable: false }
    ],
    headersAfterDelete: [
      { text: "Name", value: "serveyorname" },
      { text: "Phone no", value: "mobno", sortable: false },
      { text: "Email", value: "serveyoremail", width: 130, sortable: false },
      { text: "State", value: "surveyorstate", sortable: false },
      { text: "Zip", value: "surveyorzip", sortable: false },
      { text: "City", value: "surveyorcity", sortable: false },
      {
        text: "Surveyor type",
        value: "surveyortype_id",
        width: 110,
        sortable: false
      }
    ],
    headers1: [
      { type: "checkbox", value: "checkData", sortable: false },
      { text: "Name", value: "serveyorname" },
      { text: "Phone no", value: "mobno", sortable: false },
      { text: "Email", value: "serveyoremail", width: 130, sortable: false },
      { text: "State", value: "surveyorstate", sortable: false },
      { text: "Zip", value: "surveyorzip", sortable: false },
      { text: "City", value: "surveyorcity", sortable: false },
      {
        text: "Surveyor type",
        value: "surveyortype_id",
        width: 110,
        sortable: false
      }
    ],
    broadcaststatus: false,
    getAnnouncements: [],
    tableLoading: false,
    timeout: 1700,
    text: "",
    alertNegetive: false,
    alertPositive: false,
    headers: [
      {
        text: "Title",
        value: "text",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "List Name",
        value: "announcementslistname",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "Created On",
        align: "start",
        value: "createdon",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "Action",
        value: "Action",
        sortable: false,
        class: "grey lighten-2",
        width: "100"
      }
    ]
  }),
  created() {
    this.getAllAnnouncements();
    this.getCountry();
  },
  watch: {
    dateAdd() {
      this.dateFormattedView = this.formatDate(this.dateAdd);
    }
  },
  methods: {
    async listNameChangeMethod(value) {
      this.surveyorListName = [];
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "AnnouncementList_getAllAnnouncementSubscribers",
        input: {
          listid: value
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.surveyorListName = res.data.data.data;
      } catch (error) {
        return error.response;
      }
    },
    multipleMethod() {
      if (this.multiple == true) {
        this.clearData();
      }
    },
    formatDate(date) {
      //   console.log(date);
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");

      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getCountry() {
      this.countryName = CountryJSON;
      var contryListDemo = [];
      var row = {};

      var self = this;
      self.countryName.forEach(function(element) {
        row = {
          countryWithCC: element.name + "(" + element.dial_code + ")",
          dial_cc: element.dial_code
        };
        contryListDemo.push(row);
      });

      this.contryList = contryListDemo;
    },
    actionMethod(item) {
      this.itemBroadcast = item;
      this.itemBroadcastStatus = true;
      item = [];
    },
    clickOfBack() {
      this.Channel = "";
      this.descriptnBroadcast = "";
      this.croppa.refresh();
      this.broadcaststatus = false;
    },
    async uploadMediaToS3() {
      if (this.croppa.hasImage()) {
        var croppa_data = this.croppa.generateDataUrl("image/jpeg");
        this.basedata = croppa_data.replace("data:image/jpeg;base64,", ""); // To remove base64 initial type image value, as server does not support it
        var s3Client = new aws.S3({
          region: "us-east-1",
          accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
          secretAccessKey: "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"
        });
        var type = 3;
        var keyValue =
          this.$store.getters.get_orgId +
          "/" +
          type +
          "/" +
          "broadcast_" +
          Date.now() +
          ".jpeg";
        var params = {
          Bucket: "adjustermate-stage",
          Key: keyValue,
          Body: Buffer.from(this.basedata, "base64"),
          // ContentType: contentType,
          ACL: "public-read-write"
        };

        s3Client.putObject(params, function(err, data) {
          console.log(err);
          console.log(data);
        });
        type = 3;
        var url =
          "https://adjustermate-stage.s3.amazonaws.com" + "/" + keyValue;
        //  console.log(url);
        return url;
      } else {
        return null;
      }
    },

    async sendBroadcastToList() {
      var someFormattedDate = moment()
        .add(2, "months")
        .format("MM/DD/YYYY");

      this.loading = true;
      if (this.announcement == "") {
        this.loading = false;
        this.text = "Please Select List Name";
        this.alertNegetive = true;
      } else {
        var arrayData;
        var self = this;
        self.announcementList.forEach(function(element) {
          if (self.announcement == element.list_id) {
            arrayData = element.list_data;
          }
        });
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "NewAnnouncement_CreateNewAnnouncement",
          input: {
            text: this.Channel,
            mediatype: 1,
            mediaurl: await this.uploadMediaToS3(),
            orgid: this.$store.getters.get_orgId,
            type: 1,
            listid: this.announcement,
            surveyoridarray: arrayData,
            details: this.descriptnBroadcast,
            infourl: this.urlinformatin != "" ? this.urlinformatin : null,
            annoucementmobNumber:
              this.annoucementMobile != "" ? this.annoucementMobile : null,
            annoucementccode:
              this.annoucementMobileCode != "Select code"
                ? this.annoucementMobileCode.replace("+", "")
                : null,
            expiredate:
              this.dateFormattedView != ""
                ? this.parseDate(this.dateFormattedView)
                : this.parseDate(someFormattedDate)
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var announcementList = res.data.data.data;
          console.log(announcementList);
          this.dialogBroadcast = false;
          this.announcement = [];
          this.surveyorListName = [];
          this.Channel = "";
          this.text = "Successfully Sent";
          this.alertPositive = true;
          this.descriptnBroadcast = "";
          this.loading = false;
          this.initialIMage = "";
          this.getAllAnnouncements();
          this.croppa.refresh();
          this.broadcaststatus = false;
          this.clearData();
        } catch (error) {
          return error.response;
        }
      }
    },
    clearData() {
      this.multiple = false;
      this.infrmatnUrlStatus = false;
      this.urlinformatin = "";
      this.annoucementMobile = "";
      this.dateFormattedView = "";
      this.annoucementMobileCode = "Select code";
      this.expiryDateStatus = false;

      this.callStatus = false;
    },
    async SendBroadcast() {
      if (
        this.infrmatnUrlStatus == true &&
        this.rules.Urlvalid(this.urlinformatin) == "Give Proper URL"
      ) {
        this.text = "Please Enter Valid URL";
        this.alertNegetive = true;
      } else if (
        this.callStatus == true &&
        this.rules.contactNumber(this.annoucementMobile) ==
          "Only Numeric,Min-7 & Max-15"
      ) {
        this.text = "Please Enter Valid Phone Number";
        this.alertNegetive = true;
      } else if (
        this.Channel == "" ||
        this.descriptnBroadcast == "" ||
        this.Channel.trim() == "" ||
        this.descriptnBroadcast.trim() == ""
      ) {
        this.text = "Please Enter Title And Description";
        this.alertNegetive = true;
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "AnnouncementList_getAllAvailablelist",
          input: {
            orgid: this.$store.getters.get_orgId
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          this.announcementList = res.data.data.data;
          this.dialogBroadcast = true;
        } catch (error) {
          //  console.log(error.response);
          return error.response;
        }
      }
    },
    dialogBroadcastMethod() {
      this.subscribers = [];
      this.selected = [];
      this.announcement = "";
      this.surveyorListName = [];
      this.croppa.refresh();
      this.dialogBroadcast = false;
      this.getAllSurveyorsByOrgID();
      this.dialog = false;
      this.dialogList = false;
      this.step = 0;
      this.tabledataAfterDelete = [];
    },
    backForToStep1(type) {
      if (type == "step0") {
        this.step -= 1;
        this.subscribers = [];
        this.tabledataAfterDelete = [];
        this.getAllSurveyorsByOrgID();
      }
      if (type == "step1") {
        this.dialog = true;
        this.step = 1;
        this.dialogList = false;
      }
    },
    async saveAfterDelete(tabledataToPassApi, type) {
      if (type == "zero") {
        this.dialog = false;
        this.dialogList = true;
      }
      if (type == "first") {
        if (this.listName != "") {
          var arrayListData = [];
          tabledataToPassApi.forEach(function(element) {
            arrayListData.push(element.surveyorid);
          });

          var input = {
            api_key: this.$store.getters.get_OrgDetails.org_apikey,
            api_password: this.$store.getters.get_OrgDetails.org_apipassword,
            command: "AnnouncementList_createNewAnnouncementList",
            input: {
              listname: this.listName,
              orgid: this.$store.getters.get_orgId,
              cretaedby: this.$store.getters.get_UserAdminidId,
              listdata: arrayListData.join()
            }
          };
          //   console.log(input);
          try {
            const res = await axios({
              method: "post",
              url: "http://stage.adjustermate.com/PortalServices",
              data: input
            });
            this.subscribers = res.data.data.data;

            this.text = "Successfully Created ";
            this.alertPositive = true;
            this.listName = "";
            this.dialogBroadcastMethod();
          } catch (error) {
            //   console.log(error.response);
            return error.response;
          }
        } else {
          this.text = "Please Enter list Name ";
          this.alertNegetive = true;
        }
      }
    },
    createSurveyorMethod() {
      this.tabledataAfterDelete = [...this.selected];

      this.step++;
    },
    async getAllSurveyorsByOrgID() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSurveyors_getAllSurveyorsByOrgID",
        input: {
          surveyor_orgid: this.$store.getters.get_orgId,
          status: 1
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.subscribers = res.data.data.data;
        this.subscribers.forEach(function(element, index) {
          element.id = index;
        });
      } catch (error) {
        //   console.log(error.response);
        return error.response;
      }
    },
    createMethod() {
      this.broadcaststatus = true;
      this.getAllSurveyorsByOrgID();
    },

    async getAllAnnouncements() {
      this.tableLoading = true;
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetAllAnnouncements_getAnnouncements",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        if (res.data.data.success != false) {
          this.getAnnouncements = res.data.data.data;

          this.getAnnouncements.forEach(function(element) {
            element.createdon = element.createdon.split(" ")[0];
          });
          var self = this;
          this.getAnnouncements.forEach(function(element) {
            element.createdon = self.formatDate(element.createdon);
          });
          this.tableLoading = false;
        } else {
          this.getAnnouncements = [];
          this.tableLoading = false;
        }
      } catch (error) {
        //   console.log(error.response);
        return error.response;
      }
    }
  }
};
</script>